<template>
  <div class="page page-roadshow-list">
    <a-button-group>
      <a-button @click="tab = 'log'" :type="tab == 'log' ? 'primary' : 'default'">短信发送记录</a-button>
      <a-button @click="tab = 'template'" :type="tab == 'template' ? 'primary' : 'default'">短信模板</a-button>
    </a-button-group>
    <div style="padding: 12px 0" v-if="tab === 'template'">
      <div class="list-table-container">
        <a-row :gutter="[16, 16]">
          <a-col :md="24" :lg="24" :xl="22" :xxl="22" v-for="item in list" :key="item.id">
            <a-card :body-style="{ padding: 0 }">
              <div class="text-indigo text-bold" slot="title">{{ item.templateKeyDesc }}</div>
              <a-space class="v-ml-auto" slot="extra">
                <a-button size="small" type="indigo" icon="sync" v-if="item.templateCode" @click="syncStatus(item.templateCode)" :loading="syncing">更新状态</a-button>
                <a-button size="small" type="primary" icon="form" v-if="!item.auditStatus || item.auditStatus == 'AUDIT_STATE_NOT_PASS'" @click="openModal(item)">修改</a-button>
                <a-button size="small" type="primary" icon="form" v-else-if="item.auditStatus == 'AUDIT_STATE_PASS'" @click="delTemplate(item.templateCode)">删除模板</a-button>
              </a-space>
              <table class="table table-plain">
                <tbody>
                  <tr>
                    <th width="110">模板名称</th>
                    <td width="32%">
                      <span :class="{ 'text-red': item.auditStatus !== 'AUDIT_STATE_PASS' }">{{ item.templateName }}</span>
                    </td>
                    <th width="100">模板描述</th>
                    <td>
                      <span>{{ item.templateKey }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>模板代码</th>
                    <td>
                      <span>{{ item.templateCode }}</span>
                    </td>
                    <th>模板状态</th>
                    <td>
                      <span :class="{ 'text-red': item.auditStatus !== 'AUDIT_STATE_PASS' }">{{ item.auditStatus }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">模板内容</th>
                    <td colspan="3">
                      <div>{{ item.templateContent }}</div>
                    </td>
                  </tr>
                  <tr v-if="item.auditStatus == 'AUDIT_STATE_NOT_PASS'">
                    <th valign="top">未通过原因</th>
                    <td colspan="3">
                      <div class="text-red">{{ item.reason }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </a-card>
          </a-col>
          <!-- <a-col :md="24" :lg="24" :xl="24" :xxl="12" v-for="key in Object.keys(templates)" :key="key">
            <div class="panel-info-section" style="height: 160px">
              <div class="panel-info-section-title flex items-center">
                <a-icon type="caret-right" class="text-primary" />
                <span class="text-bold">{{ templates[key].templateKeyDesc }}</span>
                <a-space class="v-ml-auto">
                  <a-button size="small" type="primary" icon="sync" v-if="templates[key].auditStatus != 'AUDIT_STATE_PASS'" @click="syncStatus(key)" :loading="syncing">更新状态</a-button>
                  <a-button size="small" type="primary" icon="form" v-if="templates[key].auditStatus == 'AUDIT_STATE_NOT_PASS'" @click="openModal(key, true)">修改</a-button>
                </a-space>
              </div>
              <table class="table table-plain" v-if="templates[key] && templates[key].templateCode">
                <tbody>
                  <tr>
                    <th width="100">模板名称</th>
                    <td width="32%">
                      <span :class="{ 'text-red': templates[key].auditStatus !== 'AUDIT_STATE_PASS' }">{{ templates[key].templateName }}</span>
                    </td>
                    <th width="100">模板描述</th>
                    <td>
                      <span>{{ key }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>模板代码</th>
                    <td>
                      <span>{{ templates[key].templateCode }}</span>
                    </td>
                    <th>模板状态</th>
                    <td>
                      <span :class="{ 'text-red': templates[key].auditStatus !== 'AUDIT_STATE_PASS' }">{{ templates[key].auditStatus }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>模板内容</th>
                    <td colspan="3">
                      <div>{{ templates[key].templateContent }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <a-empty :image="emptyImage">
                  <div slot="description">
                    暂未设置，
                    <span class="text-indigo hover-line" @click="openModal(key)">
                      <a-icon type="plus" />
                      添加模板
                    </span>
                  </div>
                </a-empty>
              </div>
            </div>
          </a-col> -->
        </a-row>
      </div>
    </div>
    <div v-else-if="tab === 'log'">
      <div class="list-options v-mt-sm">
        <a-form layout="inline" class="options-form">
          <a-row :gutter="24">
            <a-col span="8">
              <a-form-item :colon="false" label="手机号码"><a-input placeholder="手机号码" @keyup.enter="loadSms()" allow-clear v-model="form.phone" size="default" style="width: 200px" /></a-form-item>
            </a-col>
            <a-col span="8">
              <a-form-item :colon="false" label="短信类型">
                <a-select placeholder="请选择" v-model="form.smsType" size="default" style="width: 200px" allowClear>
                  <a-select-option v-for="item in smsTypes" :key="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="flex items-center v-my-sm">
        <div class="v-ml-auto">
          <a-space>
            <a-button type="primary" icon="search" size="small" @click="loadSms()">查询</a-button>
            <!-- <a-button icon="plus" type="primary" size="small" @click="$router.push('add')">新增项目</a-button> -->
            <!-- <a-button icon="file-excel" type="danger" size="small" @click="$router.push('add')">导出</a-button> -->
          </a-space>
        </div>
      </div>
      <div class="list-table-container">
        <div class="list-toolbar flex items-center">
          <div class="list-toolbar-extra">
            共
            <span class="text-primary font-special">{{ pagination.total }}</span>
            条记录
          </div>
          <div class="list-pagination v-ml-auto">
            <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
          </div>
        </div>
        <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :columns="columns" :data-source="list" :scroll="{ x: '100%' }" rowKey="smsId">
          <template slot="smsType" slot-scope="text, record">
            <span v-if="smsTypes.some(v => v.value === record.smsType)">{{ smsTypes.find(v => v.value === record.smsType).label }}短信</span>
          </template>
        </a-table>
        <div class="list-toolbar flex items-center">
          <div class="list-toolbar-extra">
            共
            <span class="text-primary font-special">{{ pagination.total }}</span>
            条记录
          </div>
          <div class="list-pagination v-ml-auto">
            <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
          </div>
        </div>
      </div>
    </div>
    <a-modal :confirmLoading="saving" :visible="modalVisible" :width="600" @cancel="cancelModal" @ok="handleSubmit" centered :title="modalTitle">
      <a-form-model autocomplete="off" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item v-if="saveForm.id">
          <span slot="label">
            <!-- <i class="required-mark">*</i> -->
            模板代码
          </span>
          <a-input placeholder="模板代码" v-model="saveForm.templateCode" ref="templateCode" readonly disabled></a-input>
          <div class="ant-form-explain text-grey">长度为1~30个字符</div>
        </a-form-item>
        <a-form-item>
          <span slot="label">
            <i class="required-mark">*</i>
            模板名称
          </span>
          <a-input placeholder="模板名称" v-model="saveForm.templateName" ref="templateName"></a-input>
          <div class="ant-form-explain text-grey">长度为1~30个字符</div>
        </a-form-item>
        <a-form-item>
          <span slot="label">
            <i class="required-mark">*</i>
            模板内容
          </span>
          <a-textarea :rows="6" placeholder="示例：您正在申请手机注册，验证码为：${code}，5分钟内有效！" v-model="saveForm.templateContent" ref="templateContent"></a-textarea>
          <div class="ant-form-explain text-grey">长度为1~500个字符</div>
        </a-form-item>
        <a-form-item>
          <span slot="label">
            <i class="required-mark">*</i>
            模板说明
          </span>
          <a-textarea :rows="3" placeholder="申请说明" v-model="saveForm.remark" ref="remark"></a-textarea>
          <div class="ant-form-explain text-grey">短信模板申请说明，是模板审核的参考信息之一</div>
        </a-form-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { listSmsTemplate, bindSmsTemplate, listSms, modifySmsTemplate, syncSmsTemplate, delSmsTemplate } from '@/api/system/sms'
const form = {
  phone: '',
  smsType: undefined,
}
export default {
  data() {
    return {
      tab: '',
      loading: false,
      list: [],
      template: {},
      templates: {},
      saving: false,
      syncing: false,
      modalVisible: false,
      modalTitle: '',
      saveForm: {
        ...form,
      },
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: 50,
          align: 'center',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '短信类型',
          ellipsis: true,
          width: 200,
          dataIndex: 'smsType',
          scopedSlots: { customRender: 'smsType' },
        },
        {
          title: '手机号码',
          // ellipsis: true,
          dataIndex: 'phone',
          width: 120,
          align: 'center',
          // scopedSlots: { customRender: 'rsName' },
        },
        {
          title: '发送时间',
          // ellipsis: true,
          dataIndex: 'sendTime',
          width: 150,
          align: 'center',
          customRender: text => (text ? text.substring(0, 16) : ''),
        },
        {
          title: '短信内容',
          // ellipsis: true,
          dataIndex: 'content',
        },
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      form: { ...form },
      modified: false,
    }
  },
  computed: {
    smsTypes: vm => vm.$store.state.app.smsTypes,
  },
  watch: {
    tab(tab) {
      if (tab === 'template') {
        this.load()
      } else if (tab === 'log') {
        this.loadSms()
      }
    },
  },
  methods: {
    handleSearch() {
      this.load()
    },
    handleReset() {
      this.form.resetFields()
    },
    load() {
      this.loading = true
      listSmsTemplate()
        .then(({ data }) => {
          if (data.success) {
            this.templates = data.result.reduce((prev, item) => {
              prev[item.templateKey] = item
              return prev
            }, {})
            this.list = data.result
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    loadSms(page = 1, pageSize = 10, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ...this.form,
      }
      this.loading = true
      listSms(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    openModal(template) {
      console.log(template)
      let modified = template.templateCode && !!template.templateCode.trim()
      // let template = this.templates[templateKey]
      this.modalTitle = `${modified ? '修改' : '添加'}${template.templateKeyDesc}`
      let saveForm = {
        templateName: template.templateName,
        templateType: template.templateType,
        templateContent: template.templateContent,
        remark: template.remark,
      }
      if (modified) {
        saveForm.templateType = template.templateType
        saveForm.templateCode = template.templateCode
        saveForm.id = template.id
      }
      this.saveForm = saveForm
      this.template = template
      this.modified = modified
      this.modalVisible = true
    },
    delTemplate(templateCode) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          delSmsTemplate(templateCode).then(({ data }) => {
            if (data.success) {
              this.$message.success('操作成功')
              this.load()
            }
          })
        },
      })
    },
    syncStatus(templateCode) {
      this.syncing = true
      this.$message.destroy()
      syncSmsTemplate(templateCode)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.load()
          }
          this.syncing = false
        })
        .catch(() => {
          this.syncing = false
        })
    },
    cancelModal() {
      this.modalVisible = false
    },
    handleSubmit() {
      let { templateName, templateType, templateContent, remark, templateCode } = this.saveForm
      this.$message.destroy()
      if (templateName.trim() === '') {
        this.$message.warning('请输入模板名称')
        this.$refs.templateName.focus()
        return
      }
      if (templateContent.trim() === '') {
        this.$message.warning('请输入模板名称')
        this.$refs.templateContent.focus()
        return
      }
      if (remark.trim() === '') {
        this.$message.warning('请输入模板说明')
        this.$refs.remark.focus()
        return
      }
      let { id } = this.template
      let params = {
        id,
        templateName: templateName.trim(),
        templateContent: templateContent.trim(),
        remark: remark.trim(),
        templateType,
      }
      this.saving = true
      if (this.modified) {
        params.templateCode = templateCode
        modifySmsTemplate(params)
          .then(({ data }) => {
            if (data.success) {
              this.$message.success('操作成功')
              this.load()
              this.cancelModal()
            }
            this.saving = false
          })
          .catch(() => {
            this.saving = false
          })
      } else {
        bindSmsTemplate(params)
          .then(({ data }) => {
            if (data.success) {
              this.$message.success('操作成功')
              this.load()
              this.cancelModal()
            }
            this.saving = false
          })
          .catch(() => {
            this.saving = false
          })
      }
    },
    onPageChange(page, pageSize) {
      this.loadSms(page, pageSize)
    },
  },
  mounted() {
    this.tab = this.$route.query.tab || 'log'
  },
}
</script>

<style lang="stylus" scoped>
.ant-form-item-label
  min-width 100px
</style>
